module.exports = __webpack_public_path__ + "static/img/can-mango-passionfruit.5f1d8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-mango-passionfruit.png
// module id = VhIk
// module chunks = 0